export const LEAD_TYPES = {
  COACH_LEAD_CLIENT: "coach-lead-client",
  COACH_LEAD_NOT_CLIENT: "coach-lead-not-client",
  LEAD_CLIENT: "lead-client",
} as const;
